import { render } from "./AddProductToMarket.vue?vue&type=template&id=1ab0df63"
import script from "./AddProductToMarket.vue?vue&type=script&lang=js"
export * from "./AddProductToMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__